import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-alert',
  templateUrl: './modal-alert.component.html',
  styleUrls: ['./modal-alert.component.css']
})
export class ModalAlertComponent {

  title: string = "";
  description: string = "";
  descriptionHTML: string = null;
  function: any;
  accion: any;
  /**
   * Si es true, el boton de cierre del header ejecuta la misma callback que Finalizar.
   * Por defecto false: en modales de confirmacion la X solo cancela sin ejecutar la accion principal.
   */
  headerCloseRunsFunction = false;
  constructor(public activeModal: NgbActiveModal) { }

  actionFinish() {
    this.function();
  }

  onHeaderClose(): void {
    if (this.headerCloseRunsFunction && this.function) {
      this.function();
      return;
    }
    this.activeModal.dismiss('Cross click');
  }
}
